import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountDetailPageUI from './AccountDetailPageUI.js'

class AccountDetailPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null
    }
  }

  render() {
    return (
      <AccountDetailPageUI
        context={this.props.context}
        account={this.state.account}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({account : response.account})
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    if (noBusy === 'noBusy')
      this.getAccounts(this.props.context)
    else
      this.setState({account: null},
        this.getAccounts(this.props.context)
      )
  }
}

export default withRouter(AccountDetailPageSF)
